// extracted by mini-css-extract-plugin
export default {"paymentSummary":"styles_paymentSummary__349aG","textItem":"styles_textItem__TIJqT"};